import { formatBRL } from 'dashboard/helper/lais/currency';

const statusLabel = (t, status) => {
  switch (status) {
    case 'em_andamento':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_ANDAMENTO');
    case 'liberado':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.LIBERADO');
    case 'solicitado':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.SOLICITADO');
    case 'em_transferencia':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_TRANSFERENCIA');
    case 'concluido':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CONCLUIDO');
    case 'cancelado':
      return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CANCELADO');
    default:
      return t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.NOT_INFORMED');
  }
};

const dateLabel = (t, context) => {
  switch (context) {
    case 'previsao_pagamento':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.PREVISAO_PAGAMENTO');
    case 'ultima_transferencia':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.ULTIMA_TRANSFERENCIA');
    case 'data_cancelamento':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.DATA_CANCELAMENTO');
    case 'data_liberado':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.DATA_LIBERADO');
    case 'data_solicitado':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.DATA_SOLICITADO');
    case 'data_concluido':
      return t('REAL_ESTATE_BROKER_DASHBOARD.DATES.DATA_CONCLUIDO');
    default:
      return t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.NOT_INFORMED');
  }
};

export const createRealEstateBrokerDashboardPresenter = t => {
  const money = value =>
    formatBRL(value?.amount, {
      fallback: t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.NOT_INFORMED'),
      fractionDigits: 2,
    });
  const dateValue = row => {
    if (!row?.data?.valor) {
      return t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.NOT_INFORMED');
    }

    return new Intl.DateTimeFormat('pt-BR').format(new Date(row.data.valor));
  };

  return {
    money: row => money(row?.valor),
    transferProgressLabel: row =>
      t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.TRANSFER_PROGRESS', {
        transferred: money(row?.progresso_transferencia?.valor_transferido),
        total: money(row?.valor),
      }),
    statusLabel: row => statusLabel(t, row?.status?.grupo),
    dateLabel: row => dateLabel(t, row?.data?.contexto),
    dateValue,
    dateDetail: row =>
      [dateLabel(t, row?.data?.contexto), dateValue(row)].join(
        t('REAL_ESTATE_BROKER_DASHBOARD.DATES.SEPARATOR')
      ),
    address: row =>
      [row?.endereco?.logradouro, row?.endereco?.numero]
        .filter(Boolean)
        .join(', ') ||
      t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.ADDRESS_UNAVAILABLE'),
    addressDetail: row =>
      [
        row?.endereco?.unidade,
        row?.endereco?.complemento,
        row?.endereco?.bairro,
      ]
        .filter(Boolean)
        .join(' · '),
    propertyCode: row =>
      row?.cod_imovel || t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.NOT_INFORMED'),
    propertyImage: row => row?.imagem || '',
    percentage: row =>
      t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.PERCENTAGE_VALUE', {
        value: row?.porcentagem,
      }),
    installmentLabel: row =>
      row?.tipo_comissao === 'partes'
        ? t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.INSTALLMENT_VALUE', {
            current: row?.parcela?.numero,
            total: row?.parcela?.total,
          })
        : t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.INTEGRAL_VALUE'),
    statusClass: row =>
      ({
        em_andamento: 'bg-[#FFF7E5] text-[#D69500]',
        liberado: 'bg-[#E7F4D7] text-[#6B9539]',
        solicitado: 'bg-[#EDF8F7] text-[#01988C]',
        em_transferencia: 'bg-[#E7F4D7] text-[#6B9539]',
        concluido: 'bg-[#E7F4D7] text-[#6B9539]',
        cancelado: 'bg-[#FCE9E9] text-[#E33838]',
      })[row?.status?.grupo] || 'bg-slate-100 text-slate-700',
  };
};
